import React, { useCallback, useMemo, useRef, useState } from "react";
import { SERVER_URL } from "../config/config.js";
import "./challanReport.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReportTable from "./ReportTable";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReportExcel from "./ReportExcel.js";
import { apiFetch } from "../utils/apiUtils.js";

let excelData = [];

function DeliveryCostReport({ sessionObject }) {
  const columns = useMemo(
    () => [
      {
        Header: "Date",
        accessor: "date",
        width: "100px",
        minWidth: "10px",
        Cell: ({ value }) => {
          value = value.split("T");
          return value[0];
        },
        canFilter: true,
      },
      {
        Header: "LR No",
        accessor: "lr_no",
        canFilter: true,
      },
      {
        Header: "MR No",
        accessor: "mr_no",
        canFilter: true,
      },
      {
        Header: "Consignor Name",
        accessor: "consignor_name",
        canFilter: true,
      },
      {
        Header: "Consignee Name",
        accessor: "consignee_name",
        canFilter: true,
      },
      {
        Header: "Station From",
        accessor: "station_from",
        canFilter: true,
      },
      {
        Header: "Station To",
        accessor: "station_to",
        canFilter: true,
      },
      {
        Header: "Delivery Expense",
        accessor: "delivery_expense",
        canFilter: true,
      },
      {
        Header: "Our Freight",
        accessor: "our_freight",
        canFilter: true,
      },
      {
        Header: "Case",
        accessor: "case",
        canFilter: true,
      },
      {
        Header: "Weight",
        accessor: "weight",
        canFilter: true,
      },
    ],
    []
  );

  // We'll start our table without any data
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const fetchIdRef = useRef(0);
  const abortControllerRef = useRef(null);
  let download_ref = useRef(null);
  const [dateState, setDateState] = useState({
    date_from: new Date(),
    date_to: new Date(),
    pending_trip: "2",
  });
  const [finalInput, setFinalInput] = useState({});
  const [pageState, setPageState] = useState({
    total_bilties: 0,
  });

  const fetchData = useCallback(
    async ({ pageSize, pageIndex, sortBy, customFilters, dateObject }) => {
      // This will get called when the table needs new data
      // You could fetch your data from literally anywhere,
      // even a server. But for this example, we'll just fake it.

      // Give this fetch an ID
      const fetchId = ++fetchIdRef.current;
      console.log("12323", sortBy, customFilters, fetchId);
      // Set the loading state
      setLoading(true);

      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      const controller = new AbortController();
      abortControllerRef.current = controller;

      let newObject = {};
      if (fetchId === fetchIdRef.current) {
        customFilters.created_from = String(
          sessionObject.sessionVariables.branch_id
        );

        if (dateObject.pending_trip == "1") {
          newObject.pending_trip = String(1);
        }

        newObject = { ...newObject, ...customFilters };

        let inputData = {
          paginate: { number_of_rows: pageSize, page_number: pageIndex + 1 },
          sort_fields: sortBy,
          filter_fields: newObject,
          date_dict: {
            date_from: dateObject.date_from,
            date_to: dateObject.date_to,
          },
        };

        setFinalInput(inputData);
        try {
          let response = await apiFetch(
            SERVER_URL + "/report/get_money_receipt_report",
            {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(inputData),
              signal: controller.signal,
            },
            sessionObject
          );
          let resp = await response.json();
          let setObj = {};
          if (fetchId == fetchIdRef.current) {
            if (resp["data"] && "total_rows" in resp) {
              setData(resp["data"]);
              setPageCount(Math.ceil(resp["total_rows"] / pageSize));
              setObj = {
                total_memo: resp["total_rows"],
              };
              setPageState({ ...pageState, ...setObj });
            }
          }
        } catch (error) {
          if (error.name === "AbortError") {
            console.log("Fetch aborted");
          } else {
            console.error("Fetch error:", error);
          }
        } finally {
          if (fetchId == fetchIdRef.current) {
            setLoading(false);
          }
        }
      }
    },
    []
  );

  const fetchDataDebounced = useMemo(() => _.debounce(fetchData, 300), []);

  return (
    <div className="report-challan">
      <div className="form-header">Delivery Cost Analysis Report</div>

      <div className="report-challan-table-container">
        <div className="report-field-row">
          <div>
            From Date:{" "}
            <DatePicker
              dateFormat="dd-MM-yyy"
              selected={dateState.date_from}
              onChange={(date) =>
                setDateState({
                  ...dateState,
                  ["date_from"]: date,
                })
              }
            />
          </div>
          <div>
            To Date:{" "}
            <DatePicker
              dateFormat="dd-MM-yyy"
              selected={dateState.date_to}
              onChange={(date) =>
                setDateState({
                  ...dateState,
                  ["date_to"]: date,
                })
              }
            />
          </div>
        </div>

        <ReportTable
          columns={columns}
          data={data}
          fetchData={fetchDataDebounced}
          dateObject={dateState}
          loading={loading}
          pageCount={pageCount}
        />
      </div>
      <div className="form-footer">
        <button style={{ display: "none" }}>
          <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className="download-table-xls-button"
            table="delivery_cost_report"
            filename="tablexls"
            sheet="tablexls"
            buttonText="Download as XLS"
            ref={(a) => (download_ref.current = a)}
          />
        </button>
        <button
          className="download-table-xls-button"
          onClick={async () => {
            setLoading(true);

            let inputData = {
              sort_fields: finalInput.sort_fields,
              filter_fields: finalInput.filter_fields,
              date_dict: finalInput.date_dict,
            };

            let response = await fetch(
              SERVER_URL + "/report/get_money_receipt_report",
              {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(inputData),
              }
            );

            let resp = await response.json();
            excelData = resp.data.map((item) => ({
              ...item,
              date: typeof item.date === "string" && item.date.includes("T")
                ? item.date.split("T")[0]
                : item.date,
            }));
            setLoading(false);
            download_ref.current.handleDownload();
          }}
        >
          Download as XLS
        </button>
        {ReportExcel.delivery_cost_report_excel(excelData, dateState)}
      </div>
    </div>
  );
}

export default DeliveryCostReport;
